export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-ep-slider/index.js